module.exports = __webpack_public_path__ + "img/logo5.e76efa7a.png";